import { HTMLAttributes, PropsWithChildren } from 'react';

interface Props extends HTMLAttributes<HTMLSpanElement> {}

export const ClickArea = ({ children, ...props }: PropsWithChildren<Props>) => {
  return (
    <span {...props} style={{ cursor: 'pointer', ...props.style }}>
      {children}
    </span>
  );
};

export default ClickArea;
